import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Header from "../../../components/Headers/Header";
import NotificationCard from "../../../components/Notification/NotificationCard";
import { useNotifications } from "../../../context/NotificationsContext";
import Button from "../../../components/Buttons/button";
import { getUserDetails, selectUser } from "../../../redux/slices/userSlice";
import {
  getNotifications,
  markAllReadNotifications,
  selectPersonalDashboard,
} from "../../../redux/slices/personalDashboardSlice";

export default function NotificationModule({ show, setShow, liveNotifications }) {
  const dispatch = useDispatch();
  const notifications = useNotifications();

  const { userDetails } = useSelector(selectUser);
  const { notificationsData, markNotificationsData } = useSelector(selectPersonalDashboard);

  const user = userDetails?.user;

  const [allNotifications, setAllNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState("all");

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      dispatch(getNotifications());
    }
  }, [dispatch, user, markNotificationsData]);

  useEffect(() => {
    if (notificationsData?.notifications) {
      setAllNotifications(notificationsData.notifications);
    }
  }, [notificationsData]);

  useEffect(() => {
    if (notifications && notifications.length !== 0) {
      setAllNotifications((prev) => [...notifications, ...prev]);
    }
  }, [notifications]);

  // Sort unread → read
  const sortedNotifications = [...allNotifications].sort((a, b) => {
    if (!a.is_read && b.is_read) return -1;
    if (a.is_read && !b.is_read) return 1;
    return new Date(b.created_at) - new Date(a.created_at);
  });

  const filteredNotifications =
    activeTab === "unread"
      ? sortedNotifications.filter((n) => !n.is_read)
      : sortedNotifications;

  const markAllRead = () => {
    dispatch(markAllReadNotifications());
    setAllNotifications((prev) =>
      prev.map((n) => ({ ...n, is_read: true }))
    );
  };

  return (
    <div
      onClick={() => setShow(true)}
      className="right_panel h-[100vh] md:h-[auto] flex flex-col w-full md:gap-6 lg:pl-6 lg:pr-6 lg:pt-6"
    >
      <Header
        title="Notifications"
        subHeading="Real-time messages and alerts"
        show={show}
        setShow={setShow}
      />

      <div className="bg-[#363D50] md:rounded-[24px] pb-4  min-h-[calc(100vh-63px)] md:min-h-[calc(100vh-150px)]">
        
        {/* TOP BAR */}
        <div className="flex justify-between px-3 md:px-6 pt-3 md:pt-5 items-center border-b border-gray-800 pb-3">
          <div className="flex space-x-6">
            <button
              className={`pb-2 ${
                activeTab === "all"
                  ? "text-yellow-400 border-b-2 border-yellow-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("all")}
            >
              All
            </button>

            <button
              className={`pb-2 ${
                activeTab === "unread"
                  ? "text-yellow-400 border-b-2 border-yellow-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("unread")}
            >
              Unread
            </button>
          </div>

          <Button
            onClick={markAllRead}
            className="btnHover bg-gray-700 btnText"
            outlined
          >
            Mark All as Read
          </Button>
        </div>

        {/* GRID LIST */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 px-3 md:px-6 py-4 overflow-y-auto scrollbar-hide
            ${filteredNotifications.length > 5 ? "h-[calc(100vh-138px)] md:h-[calc(100vh-250px)]" : ""}`
          }
        >          {filteredNotifications.length === 0 ? (
            <div className="text-gray-400 col-span-2">No notifications available</div>
          ) : (
            filteredNotifications.map((n) => (
              <NotificationCard key={n.id} notification={n} />
            ))
          )}
        </div>
        
      </div>
    </div>
  );
}
